import { clsx } from 'clsx';
import { useAuthContext } from 'contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { AccessType } from 'types/User';
import StatusTag from './Tag';
import { getDossierStatusColor } from '../const/statutsDossier';
import { DossierStatus, DossierStatusKeys } from '../types/Dossier';

const hasVerticalPaddingClass = (className?: string) =>
  /(?:^|\s)!?(?:py|pt|pb)-/.test(className ?? '');

export default function DossierStatusTag({
  className,
  full = false,
  status,
}: {
  status?: DossierStatus;
  full?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  const { auth } = useAuthContext();
  const isConcessionnaire =
    auth?.user.accessType === AccessType.CONCESSIONNAIRE;

  if (!status) {
    return null;
  }

  // Changement de la clé de statut pour les concessionnaires
  const statusKey =
    isConcessionnaire && DossierStatusKeys[status] === 'ChantierEnCours'
      ? 'ChantierEnCours_concession'
      : DossierStatusKeys[status];

  return (
    <StatusTag
      full={full}
      status={t(`statuts_dossier:${statusKey}`)}
      color={getDossierStatusColor(status)}
      className={clsx(
        !hasVerticalPaddingClass(className) && '!py-1',
        '!-my-0 align-middle',
        className,
      )}
    />
  );
}
